import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ITemperature {
  temperature: string|number;
  temperatureId: number;
}

interface TemperatureStore {
  selectedTemperature: ITemperature;
  setSelectedTemperature: (temperature: ITemperature) => void;
  resetTemperature: () => void;
}

const useTemperatureStore = create<TemperatureStore>()(
  persist(
    (set) => ({
      selectedTemperature: { temperature: '25°C', temperatureId: 1 }, // Default temperature

      setSelectedTemperature: (temperature) =>
        set({ selectedTemperature: temperature }),

      resetTemperature: () =>
        set({
          selectedTemperature: { temperature: '25°C', temperatureId: 1 },
        }),
    }),
    {
      name: 'temperature-storage', 
      partialize: (state) => ({
        selectedTemperature: state.selectedTemperature,
      }),
    },
  ),
);

export default useTemperatureStore;
